import { useEffect, useMemo, useState } from 'react';
import { Polyline } from '@react-google-maps/api';
import { getRemainingRoute, getRoutePath } from '../utils/routeProgress';

export default function RemainingRoute({ route, location, color }) {
    const path = useMemo(() => getRoutePath(route), [route]);
    const [travelled, setTravelled] = useState({ path, progress: 0 });
    const remaining = useMemo(() => getRemainingRoute(
        path, location, travelled.path === path ? travelled.progress : 0,
    ), [path, location, travelled]);

    useEffect(() => {
        if (travelled.path !== path || travelled.progress !== remaining.progress) {
            setTravelled({ path, progress: remaining.progress });
        }
    }, [path, remaining.progress, travelled]);

    return remaining.path.length > 1 ? (
        <Polyline path={remaining.path} options={{
            strokeColor: color, strokeOpacity: 0.8, strokeWeight: 5,
            zIndex: 2, clickable: false,
        }} />
    ) : null;
}
